<script setup lang="ts">
import { onMounted } from 'vue'
import VueFeather from 'vue-feather';

const emit = defineEmits<{
  (e: 'backButton', backUrl: string|null): void
}>()

onMounted(() => {
  emit('backButton', 'back')
})
</script>

<template>
  <div class="wrapper">
    <h2>Acerca de GoTDAH</h2>

    <p><b>GoTDAH</b> es una app que ofrece recursos gratuitos y sencillos, así
      como seguimiento evolutivo de la sintomatología, a personas con TDAH.
    </p>

    <h3>Fundación INGADA</h3>
    <p>
      Esta aplicación ha sido diseñada y promovida por la
      <b><a href="https://www.fundacioningada.net/" target="_blank">Fundación INGADA</a></b>.
    </p>
    <p class="logos"> <a href="https://www.fundacioningada.net/" target="_blank">
      <img src="@/assets/logo_ingada.png" title="Fundación INGADA"/></a></p>

    <h3>Fundación Barrié</h3>
    <p>Con el mecenazgo de la <b><a href="https://fundacionbarrie.org/">Fundación Barrié</a></b>.</p>
    <p class="logos"><a href="https://fundacionbarrie.org/" target="_blank">
      <img class="barrie" src="@/assets/logo_barrie.png" title="Fundación Barrié"/>
      </a></p>

    <h3>Tipografía OpenDyslexic</h3>
    <p>Los títulos y otros textos de esta app utilizan la tipografía
      <a href="https://opendyslexic.org/" target="_blank"><b>OpenDyslexic</b></a></p>
    <p>Esta tipografía está especialmente diseñada para mitigar síntomas comunes
      de la dislexia, haciéndolo más legible para estas personas.
    </p>

    <h3>Tipografía Inter</h3>
    <p>El resto de textos de la aplicación utiliza la tipografía <b><a href="https://rsms.me/inter/" target="_blank">Inter</a></b>,
    diseñada para facilitar y mejorar la legibilidad.</p>

    <h3>Colección de iconos «Feather Icons»</h3>
    <p>Esta aplicación hace uso de la colección de iconos <b><a href="https://feathericons.com/">Feather Icons</a></b>.</p>

    <h3>Desarrollado por aCore</h3>
    <p>Aplicación desarollada por Aplicaciones Informáticas Corporativas y Empresariales, S.L.</p>
    <p class="logos"><a href="https://www.acore.es/" target="_blank">
      <img class="acore" src="https://www.acore.es/uploads/images/acore2013/images/logo.png" title="aCore"/>
      </a></p>
  </div>
</template>

<style scoped>
h2, p {
  text-align: center;
}
p b {
  font-weight: bold;
}

.wrapper {
  max-width: 600px;
}

img {
  max-width: 100%;
}

img.barrie {
  width: 400px;
}
</style>
